import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  ImageBackground,
  Text,
} from "react-native";
import {
  blackColor,
  blockColor,
  subTitleColorRed,
  subTitleColorBlue,
  subTitleColorYellow,
  subTitleColorGreen,
  blockColorRed,
  blockColorBlue,
  blockColorYellow,
  blockColorGreen,
} from "../colors";
import windowWidth from "../windowWidth";
import { COLOR_TYPES } from "../helpers/onlyTwoDominateColors";
import t from "../../translations";

const DominateColor = ({ dominate, i, style }) => {
  const title = !i ? t('dominateColor_main') : t('dominateColor_complementary');

  const getStyleNameByColorType = (colorType, styles) => {
    switch (colorType) {
      case COLOR_TYPES.RED:
        return styles.colorRed;
      case COLOR_TYPES.BLUE:
        return styles.colorBlue;
      case COLOR_TYPES.YELLOW:
        return styles.colorYellow;
      case COLOR_TYPES.GREEN:
        return styles.colorGreen;
      default:
        return "???";
    }
  };

  const getNameOfColorByColorType = (colorType) => {
    switch (colorType) {
      case COLOR_TYPES.RED:
        return t('dominateColor_colors_red');
      case COLOR_TYPES.BLUE:
        return t('dominateColor_colors_blue');
      case COLOR_TYPES.YELLOW:
        return t('dominateColor_colors_yellow');
      case COLOR_TYPES.GREEN:
        return t('dominateColor_colors_green');
      default:
        return "???";
    }
  };

  return (
    <View style={[style]} key={i}>
      <Text style={styles.blockTextTitle}>{title}</Text>
      <Text
        style={[
          styles.blockColorText,
          getStyleNameByColorType(dominate.colorType, styles),
        ]}
      >
        {getNameOfColorByColorType(dominate.colorType)}
      </Text>
      <Text
        style={[
          styles.blockColorPercentage,
          getStyleNameByColorType(dominate.colorType, styles),
        ]}
      >
        {Math.round(dominate.value * 100)}%
      </Text>
    </View>
  );
};

export default DominateColor;

const styles = StyleSheet.create({
  blockTextTitle: {
    textAlign: "center",
    fontSize: 10,
    lineHeight: 16,
    textTransform: "uppercase",
    letterSpacing: 0.25,
    fontFamily: "Roboto",
    color: blackColor,
  },
  blockColorPercentage: {
    textAlign: "center",
    fontSize: 14,
    lineHeight: 16.41,
    paddingTop: 4,
    textTransform: "uppercase",
    letterSpacing: 0.25,
    fontFamily: "Roboto",
  },
  colorRed: {
    color: subTitleColorRed,
  },
  colorBlue: {
    color: subTitleColorBlue,
  },
  colorYellow: {
    color: subTitleColorYellow,
  },
  colorGreen: {
    color: subTitleColorGreen,
  },
  blockColorText: {
    textAlign: "center",
    fontSize: 14,
    lineHeight: 16.41,
    paddingTop: 6,
    textTransform: "uppercase",
    letterSpacing: 0.25,
    fontFamily: "Roboto",
  },
});
